import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import DescriptionRenderer, { DescriptionSegment } from "./DescriptionRenderer";

interface HoverInfoProps {
    instructions: DescriptionSegment[] | null;
}

const HoverInfo: React.FC<HoverInfoProps> = ({ instructions }) => {
    const [visible, setVisible] = useState(false);
    const wrapperRef = useRef<HTMLDivElement | null>(null);

    // Close popup when clicking outside
    useEffect(() => {
        function handleClickOutside(e: MouseEvent) {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(e.target as Node)
            ) {
                setVisible(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Responsive width
    const popupWidth =
        window.innerWidth < 480
            ? "60vw"       // Mobile
            : window.innerWidth < 768
                ? "350px"      // Tablet
                : "500px";     // Desktop

    return (
        <div
            ref={wrapperRef}
            className="position-relative d-inline-block ms-2"
        >
            <span
                onClick={() => setVisible((v) => !v)}
                style={{
                    cursor: "pointer",
                    color: "#808080",
                    fontWeight: 500
                }}
            >
                <FontAwesomeIcon icon={faCircleQuestion} /> How to Install
            </span>

            {visible && instructions && (
                <div
                    className="position-absolute p-2 shadow rounded bg-white border"
                    style={{
                        top: "120%",
                        left: 0,
                        zIndex: 2000,
                        width: popupWidth,
                        whiteSpace: "normal",
                        fontSize: "0.85rem",
                        lineHeight: "1.2rem",
                        color: "#808080"
                    }}
                >
                    <DescriptionRenderer description={instructions} />
                </div>
            )}
        </div>
    );
};

export default HoverInfo;
